import { CalculationPriceProduct } from '~/Api/User/ProductGroup/RoMaxPrice/CalculationPriceProduct';
import Price from '~/libs/Price';

export enum PriceType {
	essentialMax = 'essential-max',
	fxUpdatePrice = 'fx-update-price',
	prgPrbPrice = 'prg-prb-price',
	priPrice = 'pri-price',
	listAvgOf3Min = 'list-avg-of-3-min',
	listMin = 'list-min',
}

export interface CalculationPrice {
	fromProducts: CalculationPriceProduct[];
	price: Price;
	priceType: PriceType;
}
